import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { get, getOr } from 'lodash/fp';
import {
  FontBold,
} from '../../Components/Auth/Layout';
import useHeaderComponentsMutation from '../../Hooks/useHeaderComponentsMutation';
import Search from '../../Components/Search/Index';
import { EVENT_TITLE } from '../../Constants/AppConstants';
import { FETCH_EVENT_SCHOOL_GUESTS } from '../../GraphQL/Queries';
import useCurrentUser from '../../Hooks/userCurrentUser';
import useUserSearch from '../../Hooks/useUserSearch';
import UserList from '../../Components/UserList/Index';
import RIGHT_ARROW from '../../Images/icons/right-color-arrow.png';
import userDefaultImage from '../../Images/icons/userIcon.png';

const TeamGuests = () => {
  const {
    currentUser,
  } = useCurrentUser(true);
  const searchList = useUserSearch();
  const { eventId } = useParams();
  const { schoolId } = useParams();
  const [searchGuests, setSearchGuests] = useState([]);
  const { data: guestsData } = useQuery(
    FETCH_EVENT_SCHOOL_GUESTS, {
      skip: !currentUser,
      variables: {
        schoolId: parseInt(schoolId, 10),
        eventId: parseInt(eventId, 10),
      },
      onCompleted: (data) => {
        setSearchGuests(data.searchEventGuestBySchool);
      },
    },
  );
  const guests = getOr([], 'searchEventGuestBySchool', guestsData);

  const searchGuest = (e) => {
    if (e.target.value === '') {
      setSearchGuests(guests);
    } else {
      setSearchGuests(
        searchList(searchGuests, e.target.value),
      );
    }
  };
  useHeaderComponentsMutation({
    title: 'GUESTS',
    backLink: `/event/${eventId}/teams/${schoolId}`,
    components: [{ key: EVENT_TITLE, value: get('[0].fetchEvent.title', searchGuests) }],
  });

  return (
    <>
      <div className="mt-4" />
      <Search
        placeholder="Search"
        onChange={searchGuest}
      />
      <div className="row">
        <div className="col-12 mx-auto px-4">
          <FontBold>
            <p className="mt-4">
              Guests(
              {searchGuests.length}
)
            </p>
          </FontBold>
        </div>
      </div>
      {searchGuests.map((eventUser) => (
        <>
          <div key={eventUser.id}>
            <UserList
              user={get('fetchUser', eventUser)}
              imageAttached={userDefaultImage}
              arrowIcon={RIGHT_ARROW}
              redirectLink={`/event-manage/${eventId}/event-user-profile/${get('id', get('fetchUser', eventUser))}`}
            />
          </div>
        </>
      ))}
    </>
  );
};
export default TeamGuests;
